<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Ativação Cliente</h5>
      </div>
    </div>
    <div class="row">
      <b-container fluid>
        <div class="card">
          <div class="card-body">
            <h4 class="mb-4">
              <strong>Filtros de Busca</strong>
            </h4>
            <a-form layout="vertical">
              <div class="row">
                <div v-if="sysAdminUser" class="col-md-4">
                  <a-form-item label="Canal de Venda">
                    <a-select
                      v-model="filtrosLocal.idSalechannel"
                      @change="handleSaleChannelChange"
                    >
                      <a-select-option value=""> Selecione </a-select-option>
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in saleChannels"
                        :key="`saleChannels-${index}`"
                      >
                        {{ item.description }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div class="col-md-4" v-if="showCostCenter">
                  <a-form-item label="Centro de Custo">
                    <a-select
                      default-value="0"
                      v-model="filtrosLocal.idCostCenter"
                    >
                      <a-select-option value="0"> Selecione </a-select-option>
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in costCenters"
                        :key="`costCenters-${index}`"
                      >
                        {{ item.description }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <b-button class="col-12" @click="limparFiltros"
                    >Limpar</b-button
                  >
                </div>
                <div class="col-md-2">
                  <b-button
                    class="col-12"
                    @click="filtrar"
                    variant="outline-primary"
                    >Filtrar</b-button
                  >
                </div>
              </div>
            </a-form>
          </div>
        </div>
        <template v-if="loading">
          <div class="d-flex justify-content-center bd-highlight mb-3">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="card">
            <div class="card-body">
              <a-table
                stripped
                :columns="columns"
                :dataSource="displayItens"
                @change="onChangePage"
              >
                <span slot="dtTransaction" slot-scope="text">
                  {{ moment(text).format("DD/MM/YYYY HH:mm:ss") }}</span
                >
     
                <div slot="expandedRowRender" slot-scope="record">
                  <h4 class="mb-4">
                    <strong>Configurações</strong>
                  </h4>
                  <a-form :form="form" layout="vertical">
                    <div class="row">
                      <div class="col-md-6">
                        <a-form-item
                          label="Email"
                          has-feedback
                          validate-status="success"
                        >
                          <a-input
                            placeholder="Email"
                            v-model="record.pagSeguroISOUsername"
                            addonBefore="Copiar"
                            v-clipboard:copy="record.pagSeguroISOUsername"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-md-6">
                        <a-form-item label="Senha">
                          <a-input
                            placeholder="Senha"
                            v-model="record.pagSeguroISOPassword"
                            addonBefore="Copiar"
                            v-clipboard:copy="record.pagSeguroISOPassword"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-md-6">
                        <a-form-item label="Url">
                          <a-input
                            placeholder="http://"
                            v-model="record.pagSeguroISOEndPoint"
                            addonBefore="Copiar"
                            v-clipboard:copy="record.pagSeguroISOEndPoint"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-md-6">
                        <a-form-item label="Adress 2">
                          <a-input placeholder="Apartment, studio, or floor" />
                        </a-form-item>
                      </div>
                      <div class="col-md-6">
                        <a-form-item label="City">
                          <a-input />
                        </a-form-item>
                      </div>
                      <div class="col-md-2">
                        <a-form-item label="Zip">
                          <a-input />
                        </a-form-item>
                      </div>
                      <div class="col-12">
                        <a-form-item>
                          <button type="button" class="btn btn-light px-5">
                            Sign in
                          </button>
                        </a-form-item>
                      </div>
                    </div>
                  </a-form>

                  <!-- idMerchant: 3816
idPagSeguroISOUserType: 0
pagSeguroISOEndPoint: "https://tf4mx2euv4.execute-api.us-west-2.amazonaws.com?IdMerchant=3816&TransactionFrom=Merchant"
pagSeguroISOPassword: "18de5b7ffbf54cMP@#"
pagSeguroISOStatus: 1
pagSeguroISOUsername: "05170703325-usemuse@ec.metapay.com.br"
pagSeguroId: "159233640"
pagSeguroSync: false
saleChannel: "UseMuse"
socialReason: "DANNUSIA MARIA LIMA REIS" -->

                  <!-- <span slot="moneyDisplay" slot-scope="text">
                    {{ text | money }}</span
                  >
                  <span slot="dateDisplay" slot-scope="text">
                    {{ text | date }}</span
                  >
                  <span slot="installment" slot-scope="text"> {{ text }}x</span> -->
                </div>

                <template slot="name" slot-scope="text, record">
                  <editable-cell
                    :text="text"
                    @change="onCellChange(record.key, 'name', $event)"
                  />
                </template>

                <template slot="transactionButton" slot-scope="text">
                  <b-button size="sm" :href="`/transaction/${text}`"
                    ><i class="fe fe-eye"></i
                  ></b-button>
                </template>
              </a-table>
            </div>
          </div>
        </template>
      </b-container>
    </div>
  </div>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import moment from "moment";
import { MerchantConfigResource } from "@/resources/MerchantConfig.resource.js";

export default {
  name: "ListaEquipamentos",
  data() {
    return {
      loading: false,
      filtrosLocal: {
        index: 1,
        size: 25,
        idCostCenter: null,
        idSaleChannel: null,
      },
      itens: [],
      costCenters: [],
      saleChannels: [],
      displayItens: [],
      selectedRowKeys: [],
      columns: [
        { title: "#", dataIndex: "idMerchant", key: "idMerchant" },
        { title: "Parceiro", dataIndex: "saleChannel", key: "saleChannel" },
        { title: "Estabelecimento", dataIndex: "socialReason", key: "socialReason" },
        { title: "ID Pag", dataIndex: "pagSeguroId", key: "pagSeguroId" },
        { title: "Sincronizado", dataIndex: "pagSeguroSync", key: "pagSeguroSync" },
        { title: "Ações", dataIndex: "actions", key: "actions" },
      ],
      innerColumns: [
        {
          title: "Email",
          dataIndex: "pagSeguroISOUsername",
          key: "pagSeguroISOUsername",
        },
        {
          title: "Senha",
          dataIndex: "pagSeguroISOPassword",
          key: "pagSeguroISOPassword",
        },
        // {
        //   title: "Data Pagamento",
        //   dataIndex: "dtPayment",
        //   key: "dtPayment",
        //   scopedSlots: { customRender: "dateDisplay" }
        // },
        // {
        //   title: "Parcela",
        //   dataIndex: "installment",
        //   key: "installment",
        //   scopedSlots: { customRender: "installment" }
        // },
        // {
        //   title: "Valor Bruto",
        //   dataIndex: "grossAmount",
        //   key: "grossAmount",
        //   scopedSlots: { customRender: "moneyDisplay" }
        // },
        // {
        //   title: "Valor Líquido",
        //   dataIndex: "netAmount",
        //   key: "netAmount",
        //   scopedSlots: { customRender: "moneyDisplay" }
        // }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 75],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      merchants: [],
      dipositivoEditar: null,
    };
  },
  methods: {
    moment,
    onCopy: function (e) {
      alert("You just copied: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy texts");
    },
    getCostCenters() {
      this.$api
        .get("v1/CostCenter/keyvalue")
        .then((result) => {
          this.costCenters = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    getSaleChannels() {
      this.$api
        .get("v1/saleChannel/keyValue")
        .then((result) => {
          this.saleChannels = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    handleSaleChannelChange() {
      this.filtrosLocal.idCostCenter = null;
    },
    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        this.loading = true;

        MerchantConfigResource.getWaitingPagSeguroData(this.filtrosLocal)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload.items;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      } else {
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },
    onChangePage(a) {
      this.filtrosLocal.index = a;
      this.getLista();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 25,
      };
      this.filtrar();
    },
    filtrar() {
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    },
  },
  computed: {
    showCostCenter() {
      try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0);
        return result;
      } catch (e) {
        return false;
      }
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.filtrar();
  },
  created() {
    if (this.showCostCenter) this.getCostCenters();
    if (this.sysAdminUser) this.getSaleChannels();
  },
};
</script>